import { ChartSeries } from "models/model";

export const checkSeriesDataXDateGreaterThanMin = (
  min: string,
  series: ChartSeries[]
) => {
  if (!min) {
    return undefined;
  }
  const minDate = new Date(min);
  return series?.some((data) =>
    data?.x?.some((value) => {
      const date = new Date(value);
      return date < minDate;
    })
  )
    ? min
    : undefined;
};
